import React, { useEffect, useState } from "react";
import useMultiNotification from "../../hooks/useNotification";
import { Button, Card, Checkbox, Col, Row, Typography } from "antd";
import LeftCol from "../wrappers/NewEntryFormLeftColWrapper";
import RightCol from "../wrappers/NewEntryFormRightColWrapper";
import SearchComponent from "../Items/Search";
import AppSelectFilter from "../Items/AppSelectFilter";
import TableHeader from "../Items/Table/Header";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import {
  viewUsersFiltersConstants,
  viewUsersTableDesktopHeaders,
} from "../../helpers/viewUsersConstants";
import UsersTableRow from "./UsersTableRow";
import UsersItemCard from "../Items/cards/UsersItemCard";
import { getAllUsersApi } from "../../redux-toolkit/slices/dashboardSlice";
import AppPagination from "../Items/AppPagination";
import AppLoader from "../Items/loader/AppLoader";

const ViewAllUsers = () => {
  const { contextHolder, openNotification } = useMultiNotification();
  const generalState = useSelector((state: RootState) => state.general);
  const { usersData, isTrackingApiLoading } = useSelector(
    (state: RootState) => state.dashboard
  );
  const { isShowTableInDesktop } = generalState;
  const [filters, setFilters] = useState<UsersFilter>({
    searchTerm: undefined,
    sortState: undefined,
  });
  const dispatch = useAppDispatch();
  const pagination = {
    currentPage: usersData.currentPage,
    totalPages: usersData.totalPages,
    nextPage: usersData.nextPage,
    previousPage: usersData.previousPage,
    totalCount: usersData.totalCount,
    pageSize: usersData.pageSize,
  };
  //state
  const [desktopTableHeaders, setDesktopTableHeaders] = useState<
    DesktopTableHeaderOption[]
  >(viewUsersTableDesktopHeaders);
  const [activePage, setActivePage] = useState<number>(1);

  //state end
  const handleOnSearch = (search: string) => {
    setFilters({
      ...filters,
      searchTerm: search,
    });
  };

  const handleSelectChange = (value: string, filterKey: string) => {
    setFilters({
      ...filters,
      [filterKey]: value,
    });
  };

  const handleCheckBox = (checked: boolean, id: string) => {};

  useEffect(() => {
    handleFetchUsers(activePage, filters);
  }, [filters]);
  const handleFetchUsers = (activePage: number, filters: UsersFilter) => {
    let query = `?page=${activePage}`;
    if (filters.searchTerm) {
      query += `&searchTerm=${filters.searchTerm}`;
    }
    if (filters.sortState) {
      query += `&sortState=${filters.sortState}`;
    }
    dispatch(getAllUsersApi(query));
  };
  if (isTrackingApiLoading) {
    return <AppLoader />;
  }
  return (
    <>
      {contextHolder}
      <Card>
        <Row gutter={[16, 16]}>
          <LeftCol>
            <Typography className="dashboard-page-title">Users</Typography>
          </LeftCol>
          <RightCol>
            <div className="dashboard-search-container">
              <SearchComponent width="50%" onSearch={handleOnSearch} />
            </div>
          </RightCol>
        </Row>
        <Row className="mt-10 mb-10" gutter={[16, 16]}>
          <Col span={24}>
            <Typography className="dashboard-page-sub-title">
              Filters
            </Typography>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col md={6} lg={6} sm={12} xs={12}>
            <AppSelectFilter
              label={viewUsersFiltersConstants.USERS.LABEL}
              options={viewUsersFiltersConstants.USERS.options}
              onChange={(value) => handleSelectChange(value, "sortState")}
              placeHolder={viewUsersFiltersConstants.USERS.placeHolder}
            />
          </Col>
          {/* <Col md={6} lg={6} sm={12} xs={12}>
            <AppSelectFilter
              label={viewUsersFiltersConstants.ORDER_STATUS.LABEL}
              options={viewUsersFiltersConstants.ORDER_STATUS.options}
              onChange={handleSelectChange}
              placeHolder={viewUsersFiltersConstants.ORDER_STATUS.placeHolder}
            />
          </Col> */}
        </Row>
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px",
              marginTop: "10px",
            }}
            span={24}
          >
            <Button type="primary">Bulk Action</Button>
          </Col>
        </Row>
        {isShowTableInDesktop === true ? (
          <>
            <Row className="table-container">
              <TableHeader
                headOptions={desktopTableHeaders}
                handleCheckBox={handleCheckBox}
              />
            </Row>
            {usersData.entries.map((user, index) => {
              return (
                <UsersTableRow
                  key={`users-desktop-row-${index}`}
                  activeBg={index % 2 === 0 ? "#F9F9F9" : "#FFFFFF"}
                  user={user}
                />
              );
            })}
          </>
        ) : (
          <>
            <Row gutter={[16, 16]}>
              {usersData.entries.map((user, index) => {
                return (
                  <Col
                    key={`users-mobile-row-${index}`}
                    lg={12}
                    md={12}
                    xl={12}
                    xxl={12}
                    sm={24}
                    xs={24}
                  >
                    <UsersItemCard
                      user={user}
                      key={`users-mobile-card-${index}`}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        )}
        <Row className="pagination-outer-wrapper">
          <AppPagination
            pagination={pagination}
            handlePageSwitch={(page) => {
              handleFetchUsers(page, filters);
            }}
          />
        </Row>
      </Card>
    </>
  );
};
export default ViewAllUsers;
